import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { isAnalyticsEnabled, loadAnalytics, trackPageView } from '@/lib/analytics';

/**
 * Loads Google Analytics once the site settings carry an id, then reports a
 * page_view for the current route and every later navigation.
 *
 * Call it AFTER `useDocumentMeta` in the same component: effects run in
 * declaration order, so the page_view reads the route's final `document.title`.
 */
export function useAnalytics(analyticsId: string | null | undefined): void {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (!isAnalyticsEnabled() || !analyticsId) return;
    if (!loadAnalytics(analyticsId)) return;

    trackPageView({
      path: `${pathname}${search}`,
      title: document.title,
      location: window.location.href,
    });
  }, [analyticsId, pathname, search]);
}
